module.exports = __webpack_public_path__ + "img/payway-select-items-hasother.7269bfb0.png";